// extracted by mini-css-extract-plugin
export default {"text-center":"styles_text-center__rriz9","checkbox":"styles_checkbox__rXYgA"};